export const MARKER_GREY = `#6C6C6C`;

export const MARKER_RED = `rgb(217,54,69)`;

export const MARKER_GREEN = `#669A34`;

export const MARKER_PURPLE = `#5C25FB`;
